import { render, staticRenderFns } from "./clothes.vue?vue&type=template&id=57a82210&"
import script from "./clothes.vue?vue&type=script&lang=js&"
export * from "./clothes.vue?vue&type=script&lang=js&"
import style0 from "./clothes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports